import { supabase } from './supabase';

/**
 * Ensures a user record exists in the public.users table
 * This addresses the foreign key constraint issue when creating profiles
 */
export const createUser = async (id: string, email: string) => {
  try {
    // Sanitize the user ID by removing any dashes
    const sanitizedId = typeof id === 'string' ? id.replace(/-/g, '') : id;
    
    console.log(`[userService] ====== BEGIN createUser ======`);
    console.log(`[userService] Creating/ensuring user in public.users table with ID: ${sanitizedId} (original: ${id}) and email: ${email}`);
    
    // Try to create/ensure a user record exists in the public.users table
    const { data, error } = await supabase
      .from('users')
      .upsert({ 
        id: sanitizedId, 
        email, 
        created_at: new Date().toISOString() 
      }, { 
        onConflict: 'id' 
      })
      .select();
    
    if (error) {
      console.error(`[userService] CRITICAL ERROR ensuring user: ${sanitizedId}`, error);
      console.error(`[userService] Error details: ${JSON.stringify(error)}`);
      // Consider if we should throw here or if AuthContext handles this
      return null; 
    }
    
    console.log(`[userService] User creation/update successful. Response data:`, data);
    console.log(`[userService] ====== END createUser: SUCCESS ======`);
    
    return data?.[0] || null;
  } catch (err) {
    console.error(`[userService] EXCEPTION in createUser for ID ${id}:`, err);
    console.error(`[userService] ====== END createUser: EXCEPTION ======`);
    return null;
  }
};

/**
 * Checks if a user exists in the public.users table
 */
export const checkUserExists = async (id: string) => {
  try {
    // Sanitize the user ID by removing any dashes
    const sanitizedId = typeof id === 'string' ? id.replace(/-/g, '') : id;
    
    console.log(`[userService] Checking if user exists: ${sanitizedId} (original: ${id})`);
    
    const { data, error } = await supabase
      .from('users')
      .select('id')
      .eq('id', sanitizedId)
      .single();
    
    if (error) {
      console.log(`[userService] User ${sanitizedId} not found:`, error);
      return false;
    }
    
    return !!data;
  } catch (err) {
    console.error('[userService] Error checking if user exists:', err);
    return false;
  }
}; 